module.exports = __webpack_public_path__ + "img/circle-shape2.482dc50f.png";